<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> 用章类型</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="用章名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入用章名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <!-- 章类型管理表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteChapterType(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        @close="resetForm"
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑章类型' : '新增章类型'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentChapterType"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="currentChapterType.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveChapterType">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { staffList } from "@/api/staff";
import {
  stampTypeList,
  stampTypeAddOrEdit,
  stampTypeDelete,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";
import { MAX_PAGE_SIZE } from "@/utils/const";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        name: "", // 查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      optionsData: [],
      rules: {
        name: [{ required: true, message: "名称是必填项", trigger: "blur" }],
        owner: [
          { required: true, message: "负责人是必填项", trigger: "change" },
        ],
      },
      tableData: [],
      dialogVisible: false,
      currentChapterType: {
        name: "",
        owner: "",
      },
      isEdit: false, // 新增还是编辑标识
    };
  },
  created() {
    this.handleQuery();
    // 查询所有的职工信息
    this.queryAllUser();
  },
  methods: {
    queryAllUser() {
      const params = {
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      };
      staffList(params)
        .then((res) => {
          this.optionsData = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    handleQuery(page) {
      const { name } = this.queryParams;
      this.currentPage = page || 1;
      stampTypeList({
        name,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
        // console.log("res", res,type, this.currentPage, this.pageSize);
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false; // 设置为新增
      this.currentChapterType = { name: "", owner: "" }; // 清空输入框
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true; // 设置为编辑
      this.currentChapterType = { ...row };
      this.dialogVisible = true;
    },
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    saveChapterType() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {};
          if (this.isEdit) {
            params.id = this.currentChapterType.id; // 编辑时传 id
          }
          params.name = this.currentChapterType.name;
          params.owner = this.currentChapterType.owner;

          // 如果你需要调用接口，就取消下面这行注释
          stampTypeAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },
    deleteChapterType(row) {
      this.$confirm("确定删除此章类型?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          stampTypeDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
